var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3563 4.27586C11.7563 4.65675 11.7717 5.28973 11.3908 5.68966L6.33333 11L20 11C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13L6.33333 13L11.3908 18.3103C11.7717 18.7103 11.7563 19.3433 11.3563 19.7241C10.9564 20.105 10.3234 20.0896 9.94253 19.6897L3.27586 12.6897C2.90805 12.3034 2.90805 11.6966 3.27586 11.3103L9.94253 4.31035C10.3234 3.91042 10.9564 3.89498 11.3563 4.27586Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowLeft);
export default __webpack_public_path__ + "static/media/ic-arrow-left.132ac4fa88d223890464bd173d0bfba6.svg";
export { ForwardRef as ReactComponent };